module.exports = __webpack_public_path__ + "static/media/calendar-alt-solid.875edde7.svg";